const breakpoints = {
    xSmall: '350px', // mobile
    small: '576px', // mobile
    medium: '768px', // tablet - portrait mode
    large: '1024px', // tablet - landscape mode
    mLarge: '1280px', // laptop
    xLarge: '1440px', // desktop
    x2Large: '1680px',
    x3Large: '1920px' // desktop
};

const evaluateBreakpoint = (a) => {
    if(typeof window !== 'undefined' && a && window?.matchMedia) {
        const media= a``.join('').match(/(\([^)]*\))/g)
        const breakpoint = a``[1].split('px')[0];
        if(media[0].includes('max-width') && Number(breakpoint) === window.innerWidth) {
            return false;
        }
        return window.matchMedia(media).matches;
        
    }
    return false;
}

const isWidthInRange = (rangeMin, rangeMax, width) => {
    const withinMin = rangeMin ? (rangeMin < width) : true;
    const withinMax = rangeMax ?  (width < rangeMax) : true;
    return withinMin && withinMax;
}

/**
 * Check if after resize, the width has entered a new screen size
 * @param {*} currWidth old window width
 * @param {*} newWidth new window width
 * @returns Boolean
 */
const checkWidthsInSameScreenSize = (currWidth, newWidth) => {
    const breakpointWidths = Object.values(breakpoints);
    for (let i=0; i<=breakpointWidths.length; i+=1) {
        const rangeMin = (i===0) ? 0 : Number(breakpointWidths[i-1].split('px')[0]);
        const rangeMax = (i===breakpointWidths.length) ? undefined : Number(breakpointWidths[i].split('px')[0]);
        const isCurrBetweenRange = isWidthInRange(rangeMin, rangeMax, currWidth);
        const isNewBetweenRange = isWidthInRange(rangeMin, rangeMax, newWidth);
        if (isCurrBetweenRange !== isNewBetweenRange) return false;
        if (isCurrBetweenRange) return true;
    }
    return true;
}

export { evaluateBreakpoint, checkWidthsInSameScreenSize };
